import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import swal from 'sweetalert2'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useServiceProduct from '@hooks/useServiceProduct'

const confirmDelete = (updateServiceProduct, toggleCompatibleProduct) => {
  const payload = {
    callbacks: {
      action: toggleCompatibleProduct,
    },
    toastText: 'Compatible Product Removed',
  }

  swal
    .fire({
      confirmButtonColor: '#DD6B55',
      confirmButtonText: 'Yes, delete it.',
      icon: 'warning',
      showCancelButton: true,
      text: 'Are you sure?',
      title: 'Delete Compatible Product?',
    })
    .then(({ value }) => {
      if (value){
        updateServiceProduct(payload)
      }
    })
}

const CompatibleProductListItem = (props) => {
  const {
    callbacks: {
      toggleCompatibleProduct,
    },
    compatibleProduct,
  } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: { updateServiceProduct },
  } = pageContext

  const {
    serviceProduct: {
      id,
      title,
    },
    urls: {
      editServiceProductUrl,
    },
  } = useServiceProduct(compatibleProduct)

  return (
    <DashboardModuleListItem title={title}>
      <DashboardModuleListItem.TertiaryText>
        # {id}
      </DashboardModuleListItem.TertiaryText>

      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon
          onClick={() => confirmDelete(updateServiceProduct, toggleCompatibleProduct)}
          marginRight="medium"
          type="delete"
        />

        <DashboardModuleListItem.Icon
          href={`${editServiceProductUrl}?redirect=${generateRedirectUrl()}`}
          type="link"
        />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

CompatibleProductListItem.propTypes = {
  callbacks: PropTypes.object.isRequired,
  compatibleProduct: PropTypes.object.isRequired,
}

export default CompatibleProductListItem
